import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import * as resources from './translations';

const fallbackLng = 'en';
export const lngStorageKey = 'gravy-lang';

i18n
  .use(reactI18nextModule)
  .init({
    fallbackLng,
    resources,
    ns: ['mygravy'],
    defaultNS: 'mygravy',
    debug: false,
    react: {
      wait: true
    },
    cache: {
      enabled: true
    }
  });

function getCurrentLang () {
  return new Promise(async (resolve) => {
    const data = await window.localStorage.getItem(lngStorageKey);
    return resolve(data || fallbackLng);
  });
}

getCurrentLang().then(lng => i18n.changeLanguage(lng));

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js